module.exports = __webpack_public_path__ + "img/isola_conv.7d3f3b95.png";